import {FunctionComponent} from "react";
import {useSyncInfoConnectorLogic} from "./SyncInfoConnector.logic";

export const SyncInfoConnector: FunctionComponent = () => {
  useSyncInfoConnectorLogic();
  return null;
}
